import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=461bb85b&scoped=true&"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=ts&"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&id=461bb85b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461bb85b",
  null
  
)

export default component.exports